import { Component, OnInit, OnDestroy } from '@angular/core';
import { ChildrenOutletContexts } from '@angular/router';
import { Helpers } from '../../helpers/helpers';
import { ProductFilter, PuntoapuntoProductDTO } from '../../models/puntoapunto-product-dto';
import { ProductService } from '../../services/product.service';
import { ServiceService } from '../../services/service.service';
import { PuntoapuntoServiceDTO, ServiceFilter } from '../../models/puntoapunto-service-dto';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { fadeInOutAnimation } from '../../animations';
import { UserService } from '../../services/user.service';
import { PuntoapuntoUserDTO } from '../../models/puntoapunto-user-dto';
import { environment } from '../../../environments/environment';
import { Subscription } from 'rxjs';

@Component({
  templateUrl: './default-layout.component.html',
  animations: [fadeInOutAnimation]
})

export class DefaultLayoutComponent implements OnInit, OnDestroy {

  prefooterModulesSet: 'void' | 'home' | 'login' | 'inner' | 'help' = 'home';
  breadcrumbs: [{
    text?: string,
    link?: string
  }?] = [];
  backLink: [
    text?: string,
    link?: string
  ] = [];

  productFilter: ProductFilter = new ProductFilter();
  products: PuntoapuntoProductDTO[] = [];

  serviceFilter: ServiceFilter = new ProductFilter();
  services: PuntoapuntoServiceDTO[] = [];

  sublinks: {}[] = [];
  userInfo: PuntoapuntoUserDTO;
  private userDataSubscription: Subscription;

  constructor(
    private contexts: ChildrenOutletContexts,
    public helper: Helpers,
    private productService: ProductService,
    private serviceService: ServiceService,
    private userService: UserService
  ) {
    this.productFilter.Skip = 0;
    this.productFilter.Take = 10;
    this.serviceFilter.Skip = 0;
    this.serviceFilter.Take = 10;
  }

  ngOnInit() {
    this.toggleScrollToTopButton();
    this.getSublinks();
    const that = this;
    setTimeout(() => {
      that.getUserData(); 
      that.subscribeToUserChanges(); 
    }, 500);
    
  }

  ngOnDestroy() {
    if (this.userDataSubscription) {
      this.userDataSubscription.unsubscribe();
    }
  }

  subscribeToUserChanges() {
    this.userDataSubscription = this.userService.userData.subscribe(user => {
      if (user && user !== this.userInfo) {
        this.userInfo = user;
        this.reloadIssueTrackerWidget();
      }
    });
  }

  getAnimationData() {
    return this.contexts.getContext('primary')?.route?.snapshot?.data?.['animation'];
  };

  getUserData() {
    this.userService.getUserInfo().subscribe(resp => {
      console.log("getUserData", resp);
      this.userInfo = resp;
      this.injectIssueTrackerWidget();
    });
  }

  getPrefooterModulesSet(evt) {
    if (evt.prefooterModulesSet) {
      this.prefooterModulesSet = evt.prefooterModulesSet;
    } else {
      this.prefooterModulesSet = 'void';
    }
  }

  getBreadcrumbs(evt) {
    setTimeout(() => {
      if (evt.breadcrumbs) {
        this.breadcrumbs = evt.breadcrumbs;
        this.backLink = evt.backLink;
      } else {
        this.breadcrumbs = [];
        this.backLink = null;
      }
    }, 5);
  }

  getAllProducts() {
    this.productService.GetPuntoapuntoAllProductLst(this.productFilter).subscribe(resp => {
      this.products = resp;
      this.addLinkstoMainMenu('IdProduct', 'products', 'menuProductos', this.products);
    });
  }

  getAllServices() {
    this.serviceService.GetPuntoapuntoAllServiceLst(this.serviceFilter).subscribe(resp => {
      this.services = resp;
      this.addLinkstoMainMenu('IdService', 'services', 'menuServicios', this.services);
    });
  }

  addLinkstoMainMenu(idString, partialRoute, idMenu, obj) {
    const Items: any[] = [];

    for (const i in obj) {
      Items.push({
        'Id': obj[i][idString],
        'Title': obj[i]['Title'],
        'Url': partialRoute + '/detail/' + obj[i][idString],
        'Class': 'subLink',
        'Roles': [],
        'SubItems': []
      });
    };

    this.sublinks.push({ idMenu: idMenu, Items: Items });
  }

  getSublinks() {
    this.getAllProducts();
    this.getAllServices();
  }

  toggleScrollToTopButton() {
    $(window).on('scroll', function () {
      if ($(this).scrollTop() > 480) {
        $('#back-to-top').addClass('visible');
        // Verificar si el nuevo widget de issue tracker está presente
        if ($('[data-sit-key]').length || $('#sit-widget-container').length) {
          $('#back-to-top').css({ marginBottom: '3.5rem' });
        }
      } else {
        $('#back-to-top').removeClass('visible');
      }
    });
  }

  scrollToTop(tooltip: NgbTooltip) {
    const scrollDuration: number = 400;
    $('body,html').animate({
      scrollTop: 0
    }, scrollDuration);

    setTimeout(() => {
      tooltip.close();
    }, scrollDuration);

    return false;
  }

   //ISSUE TRACKER
   private injectIssueTrackerWidget(): void {
    
    // Verificar si el script ya fue cargado
    if (document.querySelector('script[data-sit-key]')) {
      return;    
    }

    let emailUser = '';


    //Datos del usuario
    let contactDataArray: { key: string; value: string }[] = [];
    if(this.userInfo != null) {
      emailUser = this.userInfo.User;
      contactDataArray.push({ key: 'Usuario', value: this.userInfo.User });    
      if (this.userInfo.RolesListString && Array.isArray(this.userInfo.RolesListString)) {
        contactDataArray.push({ key: 'Roles', value: this.userInfo.RolesListString.join(', ') });
      }
    }

    const script = document.createElement('script');
    script.src = environment.issueTrackerUrl + 'assets/js/widget.js';
    script.setAttribute('data-sit-key', environment.issueTrackerKey);
    script.setAttribute('data-sit-email', emailUser);
    script.setAttribute('data-sit-title', 'Asistencia Punto a Punto');
    script.setAttribute('data-sit-tagline', 'Te lo contamos punto por punto');    
    script.setAttribute('data-sit-position', '10,0');
    script.setAttribute('data-sit-theme', 'renault-pap');
    script.setAttribute('data-sit-user-data', JSON.stringify(contactDataArray));
    script.setAttribute('data-sit-app-url', environment.issueTrackerUrl);
    script.setAttribute('data-sit-toogle-button-text', 'Punto de ayuda');
    
    script.async = true;

    document.head.appendChild(script);
  }

  private reloadIssueTrackerWidget(): void {
    // Remover el script anterior
    const existingScript = document.querySelector('script[data-sit-key]');
    if (existingScript) {
      existingScript.remove();
    }

    // Remover el contenedor del widget si existe
    const widgetContainer = document.querySelector('#sit-widget-container');
    if (widgetContainer) {
      widgetContainer.remove();
    }

    // Remover otros elementos del widget que puedan existir
    const widgetElements = document.querySelectorAll('[data-sit-key], [class*="sit-"]');
    widgetElements.forEach(element => {
      element.remove();
    });

    // Limpiar cualquier referencia global del widget
    if ((window as any).SITWidget) {
      delete (window as any).SITWidget;
    }

    // Pequeño delay para asegurar que el DOM se limpie completamente
    setTimeout(() => {
      this.injectIssueTrackerWidget();
    }, 100);
  }
}

